module.exports = __webpack_public_path__ + "static/img/default.3780ea7f.svg";